import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import Pro from 'image/detail/pro2.png'
import styles from './index.module.less'

export default ({ isPro, name, ownerName, blogNum }) => {
  return <div className={styles['multi-img-coll-info']}>
    <div className="coll-title">
      <Icon type="m-xinjianlingganji" className="multi-img-coll-info-icon" />
      <div className="coll-title-text">
        <div className="coll-title-text-name" style={{ maxWidth: `${isPro === 1 ? 'calc(100% - 80px)' : 'calc(100% - 40px)'}` }}>{name}</div>
        {isPro === 1 && <img src={Pro} className="multi-img-coll-info-img" />}
      </div>
    </div>
    <div className="coll-detail">
      <div className="coll-detail-blogNum">款式<span style={{ marginLeft: '4px', color: 'var(--m-text-1)' }}>{blogNum}</span></div>
      <div className="coll-detail-line" />
      <div className="coll-detail-userName">{ownerName}</div>
    </div>
  </div>
}
